<template>
  <modal-default
    ref="continueSessionModal"
    title="Continue Session"
    hide-close-button
  >
    <p class="re_login_modal--text">Your session is about to end due to inactivity and you will be logged off
      automatically. Would you like to stay signed in?</p>

    <template v-slot:footer>
      <div class="flex flex-between" style="width: 100%">
        <button-link
          :disabled="isLoggingIn"
          :loading="isLoggingIn"
          @click="logout"
        >
          Logout
        </button-link>

        <button-default
          :disabled="isLoggingIn"
          :loading="isLoggingIn"
          @click="continueSession"
        >
          Stay Logged In
        </button-default>
      </div>
    </template>
  </modal-default>
</template>

<script>
import api from "../../../api";
import auth from "../../../api/auth";
import router from "../../../router";

export default {
  name: "ContinueSessionModal",
  data() {
    return {
      isLoggingIn: false,
    }
  },
  methods: {
    open() {
      this.$refs.continueSessionModal.open();
    },
    logout() {
      auth.logout().then(() => {
        router.push({name: 'login'});
      });
    },
    continueSession() {
      this.isLoggingIn = true;

      api.auth.continueSession().then(() => {
        this.$refs.continueSessionModal.close();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.re_login_modal--text {
  line-height: 1.3;
}
</style>
